export const pl = {
  languages: {
    english: "Angielski",
    spanish: "Hiszpański",
    dutch: "Holenderski",
    french: "Francuski",
    portuguese: "Portugalski",
    italian: "Włoski",
    german: "Niemiecki",
    polish: "Polski",
    romanian: "Rumuński",
    greek: "Grecki",
    //TODO: add new language here
  },
  loginPage: {
    title: "Zaloguj się",
    email: "Email",
    placeholder: "Wprowadź swój adres e-mail",
    buttonText: "Zaloguj",
    loginMessage:
      "Na podany adres e-mail została wysłana wiadomość. Kliknij link w wiadomości e-mail, aby się uwierzytelnić.",
    noEmailMessage:
      "Użyj linku z wiadomości e-mail, która została do Ciebie wysłana, aby uruchomić ten proces.",
  },
  formPage: {
    title: "Przegląd okresowy",
    submittedMessage: "Formularz został przesłany!",
    alreadySubmittedMessage:
      "Formularz został już przesłany! Jeśli chcesz zmienić wcześniej przesłane informacje, skontaktuj się ze swoim menedżerem ds. relacji.",
    waitMessage: "Ładowanie danych, proszę czekać...",
    asteriskMessage1: "Proszę wypełnić wszystkie pola oznaczone",
    asteriskMessage2: ", ponieważ są one wymagane.",
    savedLocallyMessage:
      "Wszystkie zmiany zostaną zapisane lokalnie na Twoim urządzeniu.",
    accessFormAgain: "Możesz ponownie uzyskać dostęp do formularza, korzystając z linku",
    openPRs: "Otwarte przeglądy okresowe",
    addRelation: "Dodaj relację",
    submit: "Prześlij",
    continue: "Kontynuuj",
    addFile: "Dodaj plik",
  },
};
